import React from "react";
import { useTranslation } from "../../../hooks/useTranslation";
import { useInView } from "../../../hooks/useInView";
import ProgressiveImage from "../../Ui/ProgressiveImage/ProgressiveImage";
import tatoClubAppScreen from "../../../images/tatoClubAppScreen.webp";

const TatoClubSection = () => {
  const { t } = useTranslation();
  const [ref, isInView] = useInView(0.3);

  return (
    <section id="tatoclub" className="sp-section" style={{ paddingLeft: 32, paddingRight: 32 }}>
      <div
        ref={ref}
        className={`sp-reveal-group${isInView ? " is-visible" : ""}`}
        style={{
          maxWidth: 1240,
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 48,
          alignItems: "center",
          background: "var(--color-neutral-900)",
          color: "var(--color-neutral-100)",
          borderRadius: "var(--radius-lg)",
          padding: 52,
        }}
      >
        <div className="sp-reveal sp-reveal-left">
          <div className="tag tag-accent">{t.landingTatoClubKicker}</div>
          <h2 style={{ marginTop: 12, color: "var(--color-neutral-100)" }}>{t.landingTatoClubHeading}</h2>
          <p style={{ opacity: 0.75 }}>{t.landingTatoClubBody}</p>
          <div style={{ display: "flex", alignItems: "center", gap: 14, marginTop: 22, flexWrap: "wrap" }}>
            <button className="btn btn-primary" style={{ padding: "12px 26px", fontSize: 15 }} disabled title="Coming soon">
              {t.landingTatoClubCta}
            </button>
            <span style={{ fontSize: 12, opacity: 0.6 }}>{t.landingTatoClubSecondary}</span>
          </div>
        </div>
        <div
          className="sp-tato-photo sp-reveal sp-reveal-right"
          style={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 400,
          }}
        >
          <div
            className="sp-tato-photo-glow"
            style={{
              position: "absolute",
              width: 320,
              height: 320,
              borderRadius: "50%",
              background:
                "radial-gradient(circle, rgba(198,113,57,0.45) 0%, rgba(122,138,94,0.25) 55%, transparent 75%)",
              filter: "blur(4px)",
              zIndex: 0,
            }}
          />
          <div
            className="sp-tato-photo-frame"
            style={{
              position: "relative",
              zIndex: 1,
              width: 200,
              padding: "14px 10px",
              background: "#0b0b0c",
              borderRadius: 36,
              boxShadow: "0 30px 60px rgba(0,0,0,0.55)",
              transform: "rotate(-4deg)",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 14,
                left: "50%",
                transform: "translateX(-50%)",
                width: 64,
                height: 16,
                background: "#0b0b0c",
                borderRadius: 10,
                zIndex: 2,
              }}
            />
            <div style={{ borderRadius: 22, overflow: "hidden", lineHeight: 0, position: "relative", aspectRatio: "600 / 1301" }}>
              <ProgressiveImage
                src={tatoClubAppScreen}
                alt="Tato Club app"
                loading="lazy"
                fill
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TatoClubSection;
